import React from "react";
import { Card, Group, Title } from "@mantine/core";

const Course = (course) => {
  return (
    <Card shadow="sm" p="lg" radius="md" withBorder style={{ width: "350px", height: "450px", marginTop: "16px", display: "flex", flexDirection: "column" }}>
      <Card.Section>
        {course.image}
      </Card.Section>

      <Group position="apart" mt="md" mb="xs" align="center">
        <Title order={4} style={{ textAlign: "center" }}>{course.name}</Title>
        {course.duration}
        {course.access}
      </Group>

      <div style={{ flex: "1 1 auto", overflow: "hidden", textOverflow: "ellipsis" }}>
        {course.description}
      </div>

      <div style={{ marginTop: "auto" }}>
        {course.button}
      </div>
    </Card>
  );
}

export default Course;